import React from "react";
import { Link } from "react-router-dom";
import { LINK } from "../../utils/utils";

const showMenu = process.env.REACT_APP_SHOW_MENU === "TRUE";

function PageButton({ page, pageClass }) {
  const { name, displayName } = page;

  if (name === "menu" && !showMenu) {
    return (
      <a className={`custom-button-navbar ${pageClass}`} href={LINK.MENU}>
        {displayName}
      </a>
    );
  }

  return (
    <Link className={`custom-button-navbar ${pageClass}`} key={name} to={name}>
      {displayName}
    </Link>
  );
}

export default PageButton;
